/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Minutes_LabelInputs */

const en_us2_quick_workout_minutes_label = /** @type {(inputs: Quick_Workout_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much time do you have?`)
};

const pt_br2_quick_workout_minutes_label = /** @type {(inputs: Quick_Workout_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo você tem?`)
};

const es_419_quick_workout_minutes_label = /** @type {(inputs: Quick_Workout_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto tiempo tienes?`)
};

const pt_pt2_quick_workout_minutes_label = /** @type {(inputs: Quick_Workout_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo tens?`)
};

const fr_fr2_quick_workout_minutes_label = /** @type {(inputs: Quick_Workout_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de temps as-tu ?`)
};

const de_de2_quick_workout_minutes_label = /** @type {(inputs: Quick_Workout_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viel Zeit hast du?`)
};

const it_it2_quick_workout_minutes_label = /** @type {(inputs: Quick_Workout_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo hai?`)
};

/**
* | output |
* | --- |
* | "How much time do you have?" |
*
* @param {Quick_Workout_Minutes_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_minutes_label = /** @type {((inputs?: Quick_Workout_Minutes_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Minutes_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_minutes_label(inputs)
	if (locale === "es-419") return es_419_quick_workout_minutes_label(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_minutes_label(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_minutes_label(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_minutes_label(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_minutes_label(inputs)
	return en_us2_quick_workout_minutes_label(inputs)
});
export { quick_workout_minutes_label as "quick-workout.minutes_label" }